export default __webpack_public_path__ + "47ff459c4344d7e717b13a2c6c2f5f8b.svg";